/* Earth Energy — Collection page: smart add-to-cart, auto sort/filter submit, mobile filter drawer.
   Add opens the theme's cart drawer (theme-agnostic) and falls back to /cart. Nothing hardcoded. */
(function(){
  function openCart(){
    var sels=['[data-cart-drawer-toggle]','[data-drawer="cart"]','button[aria-controls="CartDrawer"]','a[aria-controls="CartDrawer"]','.js-drawer-open-cart','.js-cart-trigger','.cart-drawer-toggle','[data-cart-toggle]','#cart-icon-bubble'];
    try{ var cd=document.querySelector('cart-drawer'); if(cd&&typeof cd.open==='function'){ cd.open(); return true; } }catch(e){}
    for(var i=0;i<sels.length;i++){ try{ var el=document.querySelector(sels[i]); if(el){ el.click(); return true; } }catch(e){} }
    return false;
  }
  function refreshCart(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      ['cart:refresh','cart:updated','cart-updated','ajaxCart:afterCartLoad','cart:build','theme:cart:reload','cart:open','cart:added'].forEach(function(n){ try{ document.dispatchEvent(new CustomEvent(n,{bubbles:true,detail:{cart:cart}})); }catch(e){} });
      return cart;
    });
  }

  function add(btn){
    var id=btn.getAttribute('data-variant'); if(!id || btn.dataset.busy==='1') return;
    var orig=btn.innerHTML; btn.dataset.busy='1'; btn.disabled=true; btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw e; }); } return r.json(); })
      .then(function(){ btn.textContent='Added ✓'; return refreshCart(); })
      .then(function(){ if(!openCart()){ window.location.href='/cart'; } setTimeout(function(){ btn.disabled=false; btn.removeAttribute('data-busy'); btn.innerHTML=orig; },1400); })
      .catch(function(err){ btn.textContent=(err&&err.description)?'Unavailable':'Try again'; setTimeout(function(){ btn.disabled=false; btn.removeAttribute('data-busy'); btn.innerHTML=orig; },2000); });
  }

  function boot(root){
    var scope=root||document;
    var form=scope.querySelector('#EeCollForm')||document.getElementById('EeCollForm');
    // smart add
    (scope.querySelectorAll('.js-ee-add')||[]).forEach&&scope.querySelectorAll('.js-ee-add').forEach(function(b){
      if(b.dataset.i) return; b.dataset.i='1'; b.addEventListener('click',function(e){ e.preventDefault(); add(b); });
    });
    // auto-submit sort
    var sort=scope.querySelector('[data-ee-sort]');
    if(sort && !sort.dataset.i){ sort.dataset.i='1'; sort.addEventListener('change',function(){ if(form) form.submit(); }); }
    // auto-submit filter checkboxes (desktop convenience); price inputs use Apply
    scope.querySelectorAll('input[data-ee-auto][type="checkbox"]').forEach(function(c){
      if(c.dataset.i) return; c.dataset.i='1'; c.addEventListener('change',function(){ if(window.matchMedia('(min-width:900px)').matches && form) form.submit(); });
    });
    // mobile drawer
    var panel=document.getElementById('EeFilters'), scrim=document.getElementById('EeScrim');
    function openF(){ if(panel){ panel.classList.add('open'); } if(scrim){ scrim.classList.add('show'); } document.body.style.overflow='hidden'; }
    function closeF(){ if(panel){ panel.classList.remove('open'); } if(scrim){ scrim.classList.remove('show'); } document.body.style.overflow=''; }
    scope.querySelectorAll('[data-ff-open]').forEach(function(b){ if(b.dataset.i)return; b.dataset.i='1'; b.addEventListener('click',openF); });
    scope.querySelectorAll('[data-ff-close]').forEach(function(b){ if(b.dataset.i)return; b.dataset.i='1'; b.addEventListener('click',closeF); });
    if(scrim && !scrim.dataset.i){ scrim.dataset.i='1'; scrim.addEventListener('click',closeF); }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot();}); else boot();
  document.addEventListener('shopify:section:load',function(e){ boot(e.target||document); });
})();
